import gql from 'graphql-tag';

const CAMPAIGN_ORDERS_AGGREGATE_BYDATE = gql`
  query campaignOrdersAggregateByDate($where: CampaignOrderWhereInput!) {
    campaignOrders(where: $where) {
      id
      name
      startDate
      endDate
      IONumber
      productCode
      type
      advertiser {
        id
        name
        CPAcronym
        level
        parentOrg {
          id
          CPAcronym
          level
          createdAt
        }
      }
      aggregateData {
        id
        completeAttributionSummary
      }
    }
  }
`;

export default CAMPAIGN_ORDERS_AGGREGATE_BYDATE;
